///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { Box3 } from "three";
import type { Viewer } from "../Viewer";
import { zoomTo } from "./ZoomTo";

export function zoomToObjects(viewer: Viewer, handles: string[] = []): void {
  const handleSet = new Set(handles);
  const objects = [];
  viewer.scene.traverseVisible((child) => {
    if (handleSet.has(child.userData?.handle)) objects.push(child);
  });

  const extents = objects.reduce((result: Box3, object) => result.expandByObject(object), new Box3());
  if (extents.isEmpty()) extents.copy(viewer.extents);

  zoomTo(viewer, extents);
}
